import styled from 'styled-components';
import ds, { media } from 'designsystem';

const LinkWrapper = styled.a`
  display: inline-block;
  background-color: ${ds.brand('background')};
  font-family: ${ds.get('type.fontFamily.text')};
  color: ${ds.brand('text')};
  font-weight: ${ds.get('type.fontWeight.regular')};
  text-decoration: none;
  border-radius: ${ds.get('metrics.m')};
  padding: calc(${ds.get('metrics.xs')} / 2) ${ds.get('metrics.xs')};
  margin: calc(${ds.get('metrics.xs')} / 2) calc(${ds.get('metrics.xs')} / 2) 0 0;
  zoom: 0.7;
  transition-duration: 0.2s;
  
  ${media.tablet`
      font-size: ${ds.fontSize('base')};
      zoom: 1;
  `}
  
  &:hover {
  background-color: ${ds.brand('darkBackground')};
  }
`;

export default LinkWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/CallUs/ContactPerson/ContactLink/LinkWrapper.jsx